import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";

export default function Profile() {
  const [error, setError] = useState("");
  const { currentUser, logout } = useAuth();

  const history = useHistory();

  async function handleLogout() {
    setError("");

    try {
      await logout();
      history.push("/");
    } catch {
      setError("Failed to log out");
    }
  }

  return (
    <>
      <div className="section-container">
        <section className="profile-field">
          <h1 className="section-header profile">Profile</h1>
          {error && <div className="error-box">{error}</div>}
          {currentUser.displayName && (
            <p className="top-400">
              <span className="profile-info-label"> Name: </span>{" "}
              <span className="profile-info"> {currentUser.displayName} </span>
            </p>
          )}
          <p className="top-400">
            <span className="profile-info-label"> Email: </span>{" "}
            <span className="profile-info"> {currentUser.email} </span>
          </p>
          <Link to="/update-profile" className="btn top-700">
            Update Profile
          </Link>
          <button className="btn top-400" type="button" onClick={handleLogout}>
            Log Out
          </button>
        </section>
      </div>
    </>
  );
}
